import axios from 'axios';
import { requestDMPost, requestSearch } from 'modules/fetch/api';

import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import CarouselSlider from 'components/atoms/TemplateCarouselSlider';
import { Slide } from 'pure-react-carousel';
import ReactHtmlParser from 'react-html-parser';

// import './style.scss';
const sections = [];

const getParams = (keyword, groupCode) => {
  const index = sections.findIndex(sitem => sitem.type === groupCode);
  return { keyword, code: sections[index].code };
};

const handleMoreButtonClick = async data => {
  try {
    const url = 'https://www.yongin.go.kr/user/web/search/search.do';
    const params = {
      searchWord: data.keyword,
      groupCode: data.code,
    };

    const form = document.createElement('form');
    form.target = '_blank';
    form.method = 'POST';
    form.action = url;

    const searchWordInput = document.createElement('input');
    searchWordInput.type = 'hidden';
    searchWordInput.name = 'search_word';
    searchWordInput.value = params.searchWord;
    form.appendChild(searchWordInput);

    const groupCodeInput = document.createElement('input');
    groupCodeInput.type = 'hidden';
    groupCodeInput.name = 'group_code';
    groupCodeInput.value = params.groupCode;
    form.appendChild(groupCodeInput);

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  } catch (error) {
    console.log('Error:', error);
  }
};

const ListBtnElement = ({ onClickEvt, data, styleDef }) => {
  const btnElements = [];
  if (data) {
    const labels = data.label.split(',');
    const values = data.value.split(',');
    const maxResults = Math.min(labels.length, 5);

    // 최대 5개의 검색결과
    for (let i = 0; i < maxResults; i += 1) {
      let title = '';
      let url = '';

      title = labels[i] !== undefined ? labels[i] : null;
      url = values[i] !== undefined ? values[i] : null;
      url = url.replace(/&amp;/g, '&');

      btnElements.push({
        label: title,
        value: url,
        action: 'url',
      });
    }
  }

  return (
    <div>
      {btnElements.map((btn, index) => (
        <div
          key={index}
          className="_list_btn_card_button"
          onClick={e => onClickEvt(btn.value, btn.action, btn.label)}
          role="button"
          tabIndex={0}
          onKeyPress={e => {
            if (e.key === 'Enter') {
              onClickEvt(btn.value, btn.action, btn.label);
            }
          }}
          style={{ ...styleDef, padding: '10px' }}
        >
          {ReactHtmlParser(btn.label)}
        </div>
      ))}
    </div>
  );
};

const ListButtonCard = ({ boxStyle, slideBoxSet, item, viewType, onClickEvt }) => {
  const { items, type } = item;

  const slideBoxSetStyle = {
    width: `${slideBoxSet.width}px`,
    height: slideBoxSet.height,
    margin: `0 ${slideBoxSet.margin}px`,
  };
  let slideLength = 0;

  items.forEach((tempItem, idx) => {
    const desc = tempItem.text.desc;
    let group_code = '';

    switch (desc) {
      case '관련사이트':
        group_code = '01';
        break;
      case '디렉토리':
        group_code = '02';
        break;
      case '게시판':
        group_code = '03';
        break;
      case '웹페이지':
        group_code = '04';
        break;
      case '관광명소':
        group_code = '06';
        break;
      default:
        console.log(`Unhandled desc value: ${desc}`);
    }

    const section = {
      type: desc,
      code: group_code,
    };
    sections.push(section);

    // Set the slideLength
    if (tempItem.button[0].label.length !== 0) {
      slideLength += 1;
    }
  });

  const constentSet = () => {
    if (slideLength === 0) {
      return (
        <div className="_list_btn_card_title sections-none">
          <div className="_title">검색 결과가 없습니다</div>
        </div>
      );
    }

    return (
      <>
        {items.length > 0 &&
          items.map((tempItem, idx) => {
            // If the length of the label is 0, do not create the corresponding slide
            if (tempItem.button[0].label.length === 0) {
              return null;
            }

            return (
              <Slide key={`slide_${idx}`} index={idx} className="_list_btn_card" style={slideBoxSetStyle}>
                <div
                  className={`_list_btn_card_title ${
                    tempItem.text.desc === sections[0].type
                      ? 'sections-1'
                      : tempItem.text.desc === sections[1].type
                      ? 'sections-2'
                      : tempItem.text.desc === sections[2].type
                      ? 'sections-3'
                      : tempItem.text.desc === sections[3].type
                      ? 'sections-4'
                      : tempItem.text.desc === sections[4].type
                      ? 'sections-5'
                      : ''
                  }`}
                >
                  <div className="_title" style={boxStyle}>
                    {ReactHtmlParser(tempItem.text.desc)}
                    <div className="_more-button" onClick={e => handleMoreButtonClick(getParams(tempItem.textbox.desc, tempItem.text.desc))}>
                      더보기
                    </div>
                  </div>
                </div>
                {tempItem.button.map((data, number) => {
                  return data.value && data.label ? <ListBtnElement key={'list_btn_ele_' + number} styleDef={boxStyle} onClickEvt={onClickEvt} data={data} /> : '';
                })}
              </Slide>
            );
          })}
      </>
    );
  };

  return (
    <>
      <div className="_carousel_button_div">
        <CarouselSlider slideBoxSet={slideBoxSet} contentCount={slideLength} contentSet={constentSet} sliderId="searchSlider" />
      </div>
    </>
  );
};

ListButtonCard.propTypes = {
  boxStyle: PropTypes.object,
  slideBoxSet:  PropTypes.object,
  item: PropTypes.object,
  viewType: PropTypes.string,
  onClickEvt: PropTypes.func,
};
ListButtonCard.defaultProps = {
  boxStyle: {},
  slideBoxSet: {},
  item: {},
  viewType: 'advise', // advise, simulator, knowledge
  onClickEvt: null,
};

ListBtnElement.propTypes = {
  data: PropTypes.object,
  onClickEvt: PropTypes.func,
  styleDef: PropTypes.object,
};
ListBtnElement.defaultProps = {
  data: {},
  onClickEvt: null,
  styleDef: {},
};

export default ListButtonCard;
